import firebase from 'firebase'
import { Dispatch } from 'react';
import { AnyAction, Store } from 'redux';
import { AppState } from '../../store';


// Action args

interface AddWord {
    wordId: string,
    original: string,
    translation: string
};

const DUMP_ALL = '@words/dumpAll';
const ADD_WORD = '@words/addWord';
const REMOVE_WORD = '@words/removeWord';

// Actions
const actionDumpAll = () => {
    return {
        type: DUMP_ALL
    }
};

const actionAddWord = (args: AddWord) => ({
    type: ADD_WORD,
    data: args
});

const actionRemoveWord = (wordId: string) => ({
    type: REMOVE_WORD,
    data: {
        wordId
    }
});

// Thunks
export const thunkAddWord = (original: string, translation: string) => (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    let state = getState();

    if (state.auth.userIsSignedIn) {
        let newWord : Word = {
            original: original,
            translation: translation
        };

        firebase.database().ref(`users/${state.auth.uid}/words`).push().set(newWord);
    } else {
        console.log('Adding a new word is unexpected at this stage because the user is not authenticated');
    }
}

export const thunkRemoveWord = (wordId: string) => (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    let state = getState();

    if (state.auth.userIsSignedIn) {
        firebase.database().ref(`users/${state.auth.uid}/words`).child(wordId).remove();
    } else {
        console.log('Removing a new word is unexpected at this stage because the user is not authenticated');
    }
}

// Export methods
const onWordAdded = (dispatch: Dispatch<AnyAction>) => (snapshot: firebase.database.DataSnapshot) => {
    dispatch(actionAddWord({
        ...snapshot.val(),
        wordId: snapshot.key
    }));
}

const onWordRemoved = (dispatch: Dispatch<AnyAction>) => (snapshot: firebase.database.DataSnapshot) => {
    dispatch(actionRemoveWord(snapshot.key as string));
}

export const startListeningWords = (dispatch: Dispatch<AnyAction>, uid: string) => {
    firebase.database().ref(`/users/${uid}/words`).on('child_added', onWordAdded(dispatch));
    firebase.database().ref(`/users/${uid}/words`).on('child_removed', onWordRemoved(dispatch));
}

export const stopListeningWords = (dispatch: Dispatch<AnyAction>, uid: string) => {
    firebase.database().ref(`/users/${uid}/words`).off('child_added', onWordAdded(dispatch));
    firebase.database().ref(`/users/${uid}/words`).off('child_removed', onWordRemoved(dispatch));
    dispatch(actionDumpAll());
}

// Selectors
export const getWordId = (state: State, original: string, translation: string) => {
    for (const key in state.byIds) {
        if (state.byIds.hasOwnProperty(key)) {
            const word = state.byIds[key];
            if (word.original === original && word.translation === translation) {
                return key;
            }
        }
    }

    return undefined;
}

// Other
export interface Word {
    original: string,
    translation: string
}

export interface State {
    byIds: {
        [key: string] : Word
    }
}

const getInitialState = () : State => ({
    byIds: {}
})

export const reducer = (state: State = getInitialState(), action: AnyAction) => {
    switch (action.type) {
        case ADD_WORD:
        {
            let newState = {
                ...state
            };

            let data = action.data as AddWord;
            newState.byIds[data.wordId] = {
                original: data.original,
                translation: data.translation
            };

            return newState;
        }
        case REMOVE_WORD:
        {
            let newState = {
                ...state
            };

            let data = action.data;
            delete newState.byIds[data.wordId];

            return newState;
        }
        case DUMP_ALL:
            return getInitialState();
        default:
            return state;
    }
};

export const configureStore = (store: Store<AppState>) => {
}